import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import GenerateQuoteModal from "../../components/quotes/GenerateQuoteModal";
import QuotesTable from "../../components/quotes/quotesTable";

export default function CalculatedQuotes() {
  const { setInfo } = usePageNameContext();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  useEffect(() => {
    setInfo({
      name: "Calculated Quotes",
      desc: "View and manage your Calculated quotes here",
    });
  }, []);

  return (
    <>
      <GenerateQuoteModal open={modalOpen} setOpen={setModalOpen} />
      <ButtonInput 
        label="Calculate New Quote"
        onClick={() => {
          setModalOpen(true);
        }}
        classes="mt-4"
        isSubmit={false}
      />
      {/* <QuotesTable data={quotes!} isSav={customerId === wilmaSAVCustomerId} /> */}
      <QuotesTable 
        url={"/quote/calculated/paginated"} 
        isSav={false} 
      />
    </> 
  );
}